import firebase from 'firebase/app';
import 'firebase/auth';

export const userService = { login, logout, getLoggedInUser };

function login(email, password) {
  if (email && password) {
    return firebase.auth().signInWithEmailAndPassword(email.trim(), password.trim());
  }
  return Promise.reject({ message: 'Please review your email and password' });
}

function logout() {
  return firebase.auth().signOut();
}

function getLoggedInUser() {
  return firebase.auth().currentUser;
}
